/**
 * Cross-component event to request the map fly to a layer's extent.
 * Dispatched from the Data Layers sidebar, consumed by a hook bound to the map.
 */
export const LAYER_FLY_TO_EVENT = 'elda:fly-to-layer'

export function dispatchLayerFlyTo(layerId) {
  if (layerId == null) return
  window.dispatchEvent(
    new CustomEvent(LAYER_FLY_TO_EVENT, { detail: { layerId } }),
  )
}
